import { useEffect, useState } from "react";
import {
  TiSocialFacebook,
  TiSocialLinkedin,
  TiSocialYoutube,
} from "react-icons/ti";
import { motion } from "framer-motion";

import { MdEmail, MdPhone } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { HiMenu } from "react-icons/hi";
import logo from "../../common/images/logo.png";
import call from "../../common/images/call-now.png";
import MobileSidebar from "./MobileSideBar";
import { IoLogoYoutube } from "react-icons/io5";
import TopBar from "./TopBar";

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    setActivePage(window.location.pathname);
  }, []);

  return (
    <header className="w-full">
      <TopBar />

      <div className="bg-white shadow-md relative z-20 min-h-[100px] flex items-center min-w-full ">
        <div className="max-w-[1280px] mx-auto size-full flex md:px-10 px-5 justify-between items-center">
          <div className="flex items-center space-x-2">
            <motion.a
              href="/"
              className="inline-block"
              whileHover={{ scale: 1.1, opacity: 0.9 }}
              whileTap={{ scale: 0.95 }}
            >
              <img
                src={logo}
                alt="Binary Ops"
                className="md:h-10 md:w-full w-[50%] transition-all duration-300"
              />
            </motion.a>
          </div>
          <nav className="hidden md:flex space-x-6 text-black font-medium">
            <a
              href="/"
              className={`p-2 hover:text-webOranage ${
                activePage === "/" ? "text-webOranage font-semibold" : ""
              }`}
            >
              Home
            </a>
            <a
              href="/about-us"
              className={`p-2 hover:text-webOranage ${
                activePage === "/about-us"
                  ? "text-webOranage font-semibold"
                  : ""
              }`}
            >
              About Us
            </a>
            <a
              href="/contact-us"
              className={`p-2 hover:text-webOranage ${
                activePage === "/contact-us"
                  ? "text-webOranage font-semibold"
                  : ""
              }`}
            >
              Contact
            </a>
            <a
              href="/career"
              className={`p-2 hover:text-webOranage ${
                activePage === "/career" ? "text-webOranage font-semibold" : ""
              }`}
            >
              Career
            </a>

            {/* Services Dropdown */}
            <div className="relative group">
              <a
                href="/services"
                className={`p-2 flex items-center hover:text-webOranage ${
                  activePage === "/services"
                    ? "text-webOranage font-semibold"
                    : ""
                }`}
              >
                Services
                <svg
                  className="w-4 h-4 ml-1 transition-transform group-hover:rotate-180"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06-.02L10 10.44l3.71-3.25a.75.75 0 111.04 1.08l-4.24 3.72a.75.75 0 01-1.04 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>

              <div className="absolute left-0 top-[30px] z-10 mt-2 w-[250px] bg-white border shadow-lg rounded-md hidden group-hover:block">
                <a
                  href="/website-development"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/website-development"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
                  Web Development
                </a>
                <a
                  href="/android-development"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/android-development"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
                  Android Development{" "}
                </a>
                <a
                  href="/uiux-designer"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/uiux-designer"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
                  UI/UX 
                </a>
                <a
                  href="/custom-software-development"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/custom-software-development"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
                  Custom Software Development{" "}
                </a>
                <a
                  href="/point-of-sale-development"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/point-of-sale-development"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
                Point Of Sale
                </a>
                <a
                  href="/crm-development"
                  className={`block px-4 py-2 hover:bg-secondary hover:text-white rounded-md ${
                    activePage === "/crm-development"
                      ? "text-webOranage font-semibold"
                      : ""
                  }`}
                >
              CRM Development
                </a>
              </div>
            </div>

            <a
              href="/blogs"
              className={`p-2 hover:text-webOranage ${
                activePage === "/blogs" ? "text-webOranage font-semibold" : ""
              }`}
            >
              Blog
            </a>
          </nav>

          {/* Contact Info (Desktop) */}
          <div className="hidden md:flex items-center space-x-2">
            <img src={call} alt="Binary Ops" className="h-10" />
            <div className="text-sm">
              <p className="text-black">Phone Number</p>
              <motion.a
                href="tel:+441293730103"
                className="text-primary font-semibold inline-block transition-all duration-300"
                whileHover={{ scale: 1.1, color: "#F8A133" }}
                whileTap={{ scale: 0.95 }}
              >
                ( +44 ) 1293730103
              </motion.a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setSidebarOpen(true)}
              className="text-3xl text-black"
            >
              <HiMenu />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar Component */}
      <MobileSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
    </header>
  );
};

export default Header;
